// POPULAR
import bg1 from "/src/assets/images/activar/paso-1.png";
import bg1Mobile from "/src/assets/images/activar/paso-1-mobile.png";



import bg2 from "/src/assets/images/activar/paso-2.png";
import bg2Mobile from "/src/assets/images/activar/paso-2-mobile.png";

import bg3 from "/src/assets/images/activar/paso-3.png";
import bg3Mobile from "/src/assets/images/activar/paso-3-mobile.png";


import bg4 from "/src/assets/images/activar/qik-1.png";
import bg4Mobile from "/src/assets/images/activar/qik-1-mobile.png";

import bg5 from "/src/assets/images/activar/qik-2.png";
import bg5Mobile from "/src/assets/images/activar/qik-2-mobile.png";

import bg6 from "/src/assets/images/activar/qik-3.png";
import bg6Mobile from "/src/assets/images/activar/qik-3-mobile.png";

import bg7 from "/src/assets/images/activar/qik-4.png";
import bg7Mobile from "/src/assets/images/activar/qik-4-mobile.png";

export const tokeActivationTabs = {
    title: "Así de fácil activas el </br> botón de pagos Toke",
    description: "<p>Actívalo ahora en tus apps Popular o Qik, y resuelve sin </br> complicarte con el efectivo.</p>",

    tabs: [


        {
            id: "popular",
            label: "En Popular",
            steps: [
                {
                    id: 1,
                    text: "<p>Dirígete a la <br> App Popular</p>",
                    background: {
                        desktop: bg1,
                        mobile: bg1Mobile
                    }
                },
                {
                    id: 2,
                    text: "<p>Busca el botón <br> de Toke</p>",
                    background: {
                        desktop: bg2,
                        mobile: bg2Mobile
                    }
                },
                {
                    id: 3,
                    text: "<p>Dale clic y <br> ¡actívalo!</p>",
                    background: {
                        desktop: bg3,
                        mobile: bg3Mobile
                    }
                }
            ]
        },



        {
            id: "qik",
            label: "En Qik",
            steps: [
                {
                    id: 1,
                    text: "<p>Entra a tu App Qik</p>",
                    background: {
                        desktop: bg4,
                        mobile: bg4Mobile
                    }
                },
                {
                    id: 2,
                    text: "<p>Da tap en tu perfil</p>",
                    background: {
                        desktop: bg5,
                        mobile: bg5Mobile
                    }
                },
                {
                    id: 3,
                    text: "<p>Elige la opción <br> “Configurar pagos Toke”</p>",
                    background: {
                        desktop: bg6,
                        mobile: bg6Mobile
                    }
                },
                {
                    id: 4,
                    text: "<p>Vincula tu número de celular a tu Cuenta Qik y listo</p>",
                    background: {
                        desktop: bg7,
                        mobile: bg7Mobile
                    }
                }
            ]
        }

    ]
};
